import { render } from "./platform.vue?vue&type=template&id=39a3f928"
import script from "./platform.vue?vue&type=script&lang=js"
export * from "./platform.vue?vue&type=script&lang=js"

import "./platform.vue?vue&type=style&index=0&id=39a3f928&lang=css"

import exportComponent from "C:\\Users\\oozdemir\\Documents\\GitHub\\bootstrap-sample\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__